import React from 'react';

import { defaultTo, prop } from 'ramda';

import icon from '../../../images/7shifts.svg';

import { FOHImage } from '../../ingredients';

export const FOH7ShiftsIcon = (props: any) => (
  <FOHImage
    source={{ uri: icon }}
    style={{ width: 130, height: 48, ...defaultTo({}, prop('style', props)) }}
  />
);
